<template>
  <div
    class="flex flex-col justify-center items-center flex-none w-auto mb-0 font-medium rounded-full text-gray-700 bg-gray-100 px-1.5 py-2.5"
    :style="{
      paddingTop: isMobile ? '0.125rem' : '0.375rem',
      paddingBottom: isMobile ? '0.125rem' : '0.375rem',
      paddingLeft: isMobile ? '0.5rem' : '0.625rem',
      paddingRight: isMobile ? '0.5rem' : '0.625rem',
    }"
  >
    <p class="block m-0 ds-text-2xs md:ds-text-xs">{{ genderPossessiveForm }} {{ sport }}</p>
  </div>
</template>

<script>
export default {
  props: {
    sport: { type: String, required: true },
    gender: { type: String, default: '' },
  },
  computed: {
    genderPossessiveForm() {
      if (this.gender.length) {
        return this.gender === 'male' ? "Men's" : "Women's"
      }
      return this.gender
    },
    isMobile() {
      return ["xs", "sm", "mobile"].includes(this.$mq);
    },
  },
}

</script>

<style scoped>
.px-1.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.py-2.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
</style>
